import { useState, useEffect } from 'react';
import { AppBar, UserMenu, useLogout } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Avatar, Tooltip, MenuItem, InputBase } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

const CustomUserMenu = () => {
  const logout = useLogout();

  return (
    <UserMenu>
      <MenuItem onClick={logout} sx={{ color: '#d0d2d6' }}>
        <LogoutIcon sx={{ mr: 1, fontSize: 20 }} />
        Çıkış Yap
      </MenuItem>
    </UserMenu>
  );
};

export const CustomAppBar = () => {
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', handleChange);
    return () => document.removeEventListener('fullscreenchange', handleChange);
  }, []);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  return (
  <AppBar
    sx={{
      backgroundColor: '#283046',
      color: '#d0d2d6',
      boxShadow: 'none',
      borderBottom: '1px solid #404656',
      '& .RaAppBar-toolbar': {
        minHeight: 64,
      },
    }}
    userMenu={<CustomUserMenu />}
  >
    {/* Search Box */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#161d31',
        borderRadius: '8px',
        px: 2,
        py: 0.5,
        ml: 2,
        minWidth: 200,
      }}
    >
      <SearchIcon sx={{ color: '#676d7d', fontSize: 20, mr: 1 }} />
      <InputBase
        placeholder="Ara..."
        sx={{
          color: '#d0d2d6',
          fontSize: '0.875rem',
          '& ::placeholder': {
            color: '#676d7d',
            opacity: 1,
          },
        }}
      />
    </Box>

    <Box sx={{ flex: 1 }} />

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={isFullscreen ? 'Tam Ekrandan Çık' : 'Tam Ekran'}>
        <IconButton
          onClick={toggleFullscreen}
          sx={{
            color: '#676d7d',
            '&:hover': { backgroundColor: 'rgba(115, 103, 240, 0.08)', color: '#7367f0' },
          }}
        >
          {isFullscreen ? (
            <FullscreenExitIcon sx={{ fontSize: 22 }} />
          ) : (
            <FullscreenIcon sx={{ fontSize: 22 }} />
          )}
        </IconButton>
      </Tooltip>

      <Tooltip title="Ayarlar">
        <IconButton
          onClick={() => navigate('/settings')}
          sx={{
            color: '#676d7d',
            '&:hover': { backgroundColor: 'rgba(115, 103, 240, 0.08)', color: '#7367f0' },
          }}
        >
          <SettingsIcon sx={{ fontSize: 22 }} />
        </IconButton>
      </Tooltip>

      <Box sx={{ ml: 1, mr: 1, width: 1, height: 24, backgroundColor: '#404656' }} />

      <Avatar
        sx={{
          width: 36,
          height: 36,
          backgroundColor: '#7367f0',
          fontSize: '0.875rem',
          fontWeight: 600,
        }}
      >
        A
      </Avatar>
    </Box>
  </AppBar>
  );
};
